import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    Box,
} from '@mui/material';
import theme from '../../../../theme';

/**
 * Modal for setting due date for selected deficiencies
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Function} props.onClose
 * @param {Function} props.onSubmit - receives date string YYYY-MM-DD
 * @param {number} props.selectedCount
 */
const DueDateModal = ({ open, onClose, onSubmit, selectedCount }) => {
    const [dueDate, setDueDate] = useState('');
    const [error, setError] = useState('');

    const handleDateChange = (e) => {
        setDueDate(e.target.value);
        setError('');
    };

    const handleSubmit = () => {
        if (!dueDate) {
            setError('Please pick a due date');
            return;
        }
        onSubmit(dueDate);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: '100%',
                    maxWidth: '400px',
                    overflow: 'visible',
                },
            }}
        >
            <DialogTitle sx={{ pb: 1 }}>
                <Typography
                    variant="h6"
                    fontWeight={theme.typography.fontWeights.semiBold}
                    sx={{ lineHeight: 1.3 }}
                >
                    Set Due Date
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ pt: 1.5 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        fullWidth
                        label="Due Date"
                        type="date"
                        value={dueDate}
                        onChange={handleDateChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!error}
                        helperText={error}
                        sx={{
                            mt: 3,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 1,
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '12px 12px',
                                lineHeight: 1.6,
                                fontWeight: theme.typography.fontWeights.medium,
                            },
                            '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                transform: 'translateY(2px)',
                            },
                        }}
                    />

                    <Box
                        sx={{
                            bgcolor: theme.palette.grey[50],
                            borderRadius: theme.shape.borderRadius,
                            p: 2,
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            This due date will be applied to {selectedCount} selected item
                            {selectedCount === 1 ? '' : 's'}.
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="inherit">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant="contained" disabled={!dueDate}>
                    Set Due Date
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DueDateModal;
